import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/(site)/discover/experiences/page.tsx");
